import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { UserService } from '@app/services/user.service';
import { AppRoutes } from '@shared/constants/app-routes.const';
import { UserType } from '@shared/enums/user-type';
import { UserData } from '@shared/interfaces/user-data';

@Injectable({
  providedIn: 'root',
})
export class ResidentGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.userService.getCashedUserData().pipe(
      filter((userData: UserData) => !!userData),
      map((userData: UserData) => {
        if (userData.userType !== UserType.Resident) {
          return true;
        }
        return this.router.createUrlTree([AppRoutes.RESIDENT]);
      })
    );
  }
}
